import _defineProperty from "/home/appuser/diet.simeonsidieet.ee/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { createStyles } from '@mantine/styles';
var useStyles = createStyles(function (theme, _ref, getRef) {
  var _default, _outline;
  var tabPadding = _ref.tabPadding,
    orientation = _ref.orientation;
  var tabsList = {
    ref: getRef("tabsList")
  };
  return {
    tabsListWrapper: {},
    tabsList: tabsList,
    root: {
      display: orientation === "vertical" ? "flex" : "block"
    },
    pills: {
      marginRight: orientation === "vertical" ? 20 : 0
    },
    body: _defineProperty({}, orientation === "horizontal" ? "paddingTop" : "paddingLeft", theme.fn.size({
      size: tabPadding,
      sizes: theme.spacing
    })),
    default: (_default = {}, _defineProperty(_default, orientation === "horizontal" ? "borderBottom" : "borderRight", "2px solid ".concat(theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[2])), _defineProperty(_default, "& .".concat(tabsList.ref), _defineProperty({}, orientation === "horizontal" ? "marginBottom" : "marginRight", -2)), _default),
    outline: (_outline = {}, _defineProperty(_outline, orientation === "horizontal" ? "borderBottom" : "borderRight", "1px solid ".concat(theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[2])), _defineProperty(_outline, "& .".concat(tabsList.ref), _defineProperty({}, orientation === "horizontal" ? "marginBottom" : "marginRight", -1)), _outline)
  };
});
export default useStyles;